module.exports = __webpack_public_path__ + "img/6.d862e6b1.jpg";